import React from 'react';
import { Link } from "react-router-dom";

function Menu() {
  return (

        <nav className="navbar navbar-expand-sm sticky-top navbar-dark">
        <span className="position-absolute trigger"></span>
            <div className="container">
                <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbar1">
                <span className="navbar-toggler-icon"></span>
            </button>
                <div className="collapse navbar-collapse" id="navbar1">
                    <ul className="navbar-nav">
                        <li className="nav-item active">
                            <Link to="/" className="nav-link">Principal</Link>
                        </li>
                        <li className="nav-item active">
                            <Link to="/About" className="nav-link">Sobre Nós</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/Portfolio" className="nav-link">Portfolio</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/Pesq" className="nav-link">Áreas de Atuação</Link>
                        </li>
                        <li className="nav-item">
                        <Link to="/Pessoas" className="nav-link">Pesquisadores</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/Contato" className="nav-link">Contato</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    
  );
}

export default Menu;